
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "pasport",
  "use": "pasport-usage",
  "viewBox": "0 0 91.333 85.167",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 91.333 85.167\" id=\"pasport\"><g fill=\"none\"><path d=\"M19.268 59.592H71.45M24.295 59.592V19.024L45.36 8.275l21.41 10.923v40.04\" /><path d=\"M31.579 59.592V47.283h27.56v12.309M45.36 47.283v12.309M39.147 25.439h12.307v12.309H39.147z\" /></g></symbol>"
});
    sprite.add(symbol);

    export default class PasportSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="pasport" {...this.props} />;
      }
    }
  